import React, { useState } from 'react';
import { validate2FA } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { Shield, Loader2 } from 'lucide-react';
import SunsetBackground from '../components/ui/SunsetBackground';

const TwoFAVerifyPage = () => {
  const { updateToken } = useAuth();
  const [code, setCode] = useState('');
  const [verifying, setVerifying] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (code.length !== 6) {
      toast.error('Enter a 6-digit code');
      return;
    }
    setVerifying(true);
    try {
      const data = await validate2FA(code);
      if (data.access_token) {
        updateToken(data.access_token);
      }
      toast.success('Verified!');
    } catch (error) {
      const msg = error.response?.data?.detail || 'Invalid code';
      toast.error(msg);
      setCode('');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      <SunsetBackground />
      <Card className="w-full max-w-sm bg-white/95 backdrop-blur-xl border-white/40 shadow-2xl shadow-amber-900/20 relative z-10" data-testid="2fa-verify-card">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-14 h-14 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mb-3">
            <Shield className="w-7 h-7 text-[#D4AF37]" />
          </div>
          <CardTitle className="text-xl text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Two-Factor Verification
          </CardTitle>
          <p className="text-sm text-gray-500 mt-2">
            Open Google Authenticator and enter the 6-digit code for MyAiAnalysis.
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="000000"
              className="text-center text-2xl tracking-[0.5em] bg-gray-50 border-gray-200 h-14"
              autoFocus
              data-testid="2fa-verify-code-input"
            />
            <Button type="submit" disabled={verifying || code.length !== 6}
              className="w-full btn-gold h-12 text-base" data-testid="2fa-verify-submit-btn">
              {verifying ? <><Loader2 className="w-5 h-5 mr-2 animate-spin" />Verifying...</> : 'Verify'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default TwoFAVerifyPage;
